import cmsApi from '@src/services/cms-api';

const Service = {
  getVideoAsync: () => cmsApi.makeCmsCustomConfigRequest('//www.mechabreak.cn/api/config/tag/', 'zt/mechabreak_pre_dlc_20241205')
};
export default Service;
